/* permittedCharacter(String): It is a string that contains the characters that are not allowed to be entered in the text field.The Characters should be enclosed in square brackets. 
    For example, if you want to restrict the characters %, <, >, $, ', " then the permittedCharacter string should be "[<%$'"]", '^[a-zA-Z0-9]+$' for all special characters and space
*/
/* permittedCharacter(String): It is a RegularExpression string that contains the characters that are allowed to be entered in the text field.The Characters should be enclosed in square brackets. 
    For example, if you want only alphanumeric  and underscore then the permittedCharacter string should be '^[a-zA-Z0-9_]*$', '^[a-zA-Z0-9]+$' 
    Another example if first character to be only alphabet and rest can be alphanumeric then the permittedCharacter string should be "^[a-zA-Z][a-zA-Z0-9]*$"
*/

import React, { useEffect } from "react";
import "../../cssfiles/homepage.css";
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";
import { NoLuggageOutlined } from "@mui/icons-material";

export default function CustomTextFieldNew({
  id,
  defaultValue,
  value,
  width,
  fontSize,
  disabled,
  maxLength,
  onChange,
  placeholder,
  permittedCharacters,
  errorText,
  type,
}) {
  const themechange = useSelector((state) => state.themedata.theme);
  const [val, setval] = React.useState(defaultValue || "");
  const [error, setError] = React.useState("");
  const [permittedCharacter, setPermittedCharacter] = React.useState("");

  // Support both controlled (value prop) and uncontrolled (defaultValue prop) modes
  const isControlled = value !== undefined;
  const displayValue = isControlled ? value : val;

  // Only update internal state for uncontrolled mode, and remove isControlled from deps
  useEffect(() => {
    if (value === undefined && defaultValue !== undefined) {
      setval(defaultValue);
    }
  }, [defaultValue, value]);

  useEffect(() => {
    if (permittedCharacters) {
      let re = new RegExp(permittedCharacters);
      setPermittedCharacter(re);
    }
  }, [permittedCharacters]);

  return (
    <TextField
      id={id}
      type={type ? type : "text"}
      disabled={disabled != null ? disabled : false}
      required
      placeholder={placeholder ? placeholder : null}
      value={displayValue || ""}
      variant="standard"
      helperText={error} // error message
      error={error} // set to true to change the border/helperText color to red !newValue.match(permittedCharacter)
      onChange={(e) => {
        const newValue = e.target.value;
        if (permittedCharacters) {
          if (newValue.length != 0) {
            if (permittedCharacter.test(newValue)) {
              setError("");
              if (!isControlled) {
                setval(newValue);
              }
              onChange(newValue, e);
            } else {
              setError(errorText);
            }
          } else {
            if (!isControlled) {
              setval(newValue);
            }
            onChange(newValue, e);
          }
        } else {
          if (!isControlled) {
            setval(newValue);
          }
          onChange(newValue, e);
        }
      }}
      //label="Label"
      inputProps={{ maxLength: maxLength ? maxLength : 250 }}
      sx={{
        width: width ? `${width}px` : "94px",
        "& .MuiInputBase-input:focus": {
          color: "#008CD7",
        },
        "& .MuiInputBase-root": {
          fontFamily: "Roboto",
          fontSize: fontSize ? `${fontSize}px` : "16px",
          fontWeight: "700",
          color: themechange === "light" ? "#3C3C3C" : "#C1C1C1",
          //color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
        },
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: themechange === "light" ? "#C1C1C1" : "#3C3C3C",
          //WebkitBorderFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',
        },
        // '& .MuiInput-underline.Mui-disabled':{
        //     color: themechange === 'light' ? '#C1C1C1' : '#pink',
        // },
        "& .MuiInput-root .MuiInputBase-input": {
          padding: 0,
        },
        "& .MuiInputBase-root::before": {
          //borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
          borderBottom: `1px solid ${
            (disabled != null ? disabled : false) == true
              ? themechange === "light"
                ? "#C1C1C1"
                : "#3C3C3C"
              : themechange === "light"
              ? "#3C3C3C"
              : "#C1C1C1"
          }`,
        },
        "& ::-webkit-input-placeholder": {
          color: themechange === "light" ? "#3C3C3C" : "#C1C1C1",
        },
        "& .MuiInputBase-root::after": {
          borderBottom: "2px solid #008CD7",
        },
        "& .Mui-error": {
          color: "var(--RedBaseColor)",
        },
      }}
    />
  );
}
